import parse from 'html-react-parser';
import React from 'react';

export default function AboutUs({ aboutText, aboutImage }) {
  return (
    <div className="relative bg-white overflow-hidden pt-10 md:pt-24 pb-10" id="about">
      
      {/* background like hero */}
      <div className="container mx-auto px-6 sm:px-4 lg:px-0 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

        {/* TEXT SIDE */}
        <section className="relative">
          
          {/* badge */}
          <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-md">
            درباره مرکز
          </span>

          <h2 className="mt-6 text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
            درباره مرکز تصویربرداری عارف
          </h2>


          {/* glass card text */}
          <div className="mt-6 rounded-[26px] bg-white/70 backdrop-blur-xl border border-white/60
                          shadow-[0_20px_70px_rgba(2,132,199,0.10)] ring-1 ring-black/5
                          p-6 sm:p-7 text-sm sm:text-base text-slate-700 leading-8 text-justify">
            {aboutText ? parse(aboutText) : ''}
          </div>

          {/* small trust badges */}
          <div className="mt-6 flex flex-wrap gap-3">
            <span className="px-3 py-1 rounded-full text-xs font-bold bg-white/70 ring-1 ring-black/5 text-slate-600">
              تجهیزات به‌روز
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-bold bg-white/70 ring-1 ring-black/5 text-slate-600">
              تیم متخصص
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-bold bg-white/70 ring-1 ring-black/5 text-slate-600">
              گزارش دقیق
            </span>
          </div>
        </section>

        {/* IMAGE SIDE */}
        {aboutImage && (
          <div className="relative flex justify-center lg:justify-end">


              <img
                loading="lazy"
                src={`data:image/jpeg;base64,${aboutImage}`}
                alt="about"
                className="w-[95%] sm:w-[450px] rounded-[40px] lg:w-[520px] h-auto object-cover transition duration-500 group-hover:scale-[1.03]"
              />

      

          </div>
        )}

      </div>
    </div>
  );
}
